(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["graf-homepage-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.homepage-categories').forEach(function (section) {
      var grid = section.querySelector('.homepage-categories__grid');
      var track = section.querySelector('.homepage-categories__scroll-track');
      var thumb = section.querySelector('.homepage-categories__scroll-thumb');
      if (!grid || !track || !thumb) return;

      function update() {
        var ratio = grid.scrollWidth > 0 ? grid.clientWidth / grid.scrollWidth : 1;
        var thumbWidth = ratio * track.offsetWidth;
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        var thumbTravel = track.offsetWidth - thumbWidth;
        var thumbLeft = maxScroll > 0 ? (grid.scrollLeft / maxScroll) * thumbTravel : 0;
        thumb.style.width = thumbWidth + 'px';
        thumb.style.left = thumbLeft + 'px';
      }

      update();
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["graf-homepage-deal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-deal-slider]').forEach(function (slider) {
      var slides = Array.from(slider.querySelectorAll('.homepage-deal__slide'));
      if (slides.length < 2) return;
      var current = 0;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        current = ((index % slides.length) + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        slider.querySelectorAll('[data-deal-prev]').forEach(function (btn) {
          btn.style.opacity = current === 0 ? '0.6' : '1';
        });
      }

      slider.addEventListener('click', function (event) {
        if (event.target.closest('[data-deal-prev]')) {
          goTo(current - 1);
        } else if (event.target.closest('[data-deal-next]')) {
          goTo(current + 1);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tabButton = event.target.closest('[data-product-info-tab-button]');
    if (!tabButton) return;

    const container = tabButton.closest('[data-product-info-tabs]');
    if (!container) return;

    const target = tabButton.getAttribute('data-tab-target');
    if (!target) return;

    const buttons = container.querySelectorAll('[data-product-info-tab-button]');
    buttons.forEach((button) => {
      const isActive = button === tabButton;
      button.classList.toggle('product-info-tabs__tab--active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    const panels = container.querySelectorAll('[data-product-info-tab-panel]');
    panels.forEach((panel) => {
      const isMatch = panel.getAttribute('data-product-info-tab-panel') === target;
      panel.hidden = !isMatch;
    });

    // Ensure supporting images slideshow arrows work even when the tab is activated later
    const supportingSlideshow = container.querySelector(
      '[data-product-info-tab-panel="supporting-images"] .product-info-tabs__supporting-images-slideshow'
    );

    if (supportingSlideshow && !supportingSlideshow.hasAttribute('data-enhanced')) {
      const slidesContainer = supportingSlideshow.querySelector('slideshow-slides');
      const prevButton = supportingSlideshow.querySelector('.slideshow-control--previous');
      const nextButton = supportingSlideshow.querySelector('.slideshow-control--next');

      if (slidesContainer && (prevButton || nextButton)) {
        const scrollByAmount = () => slidesContainer.clientWidth || slidesContainer.offsetWidth || 0;

        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            slidesContainer.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            slidesContainer.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
          });
        }

        supportingSlideshow.setAttribute('data-enhanced', 'true');
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
